import React from 'react';
// material
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import HomeButton from "./HomeButton";
import FullImage from './FullImage'

const iconRobot = process.env.PUBLIC_URL + '/home_page/iphone.svg';

interface LeeadItemProps {
  item: number;
  title: string;
  text: string;
}

const LeadItem: React.FC<LeeadItemProps> = (props) => {
  const classes = useStyles({});
  return (
    <div className={classes.itemContainer}>
      <div className={classes.itemNumberContainer}>
        <div className={classes.itemNumber}>{props.item}</div>
      </div>
      <div className={classes.itemTextContainer}>
        <div className={classes.itemText}>{props.title}</div>
        <div className={classes.itemDescription}>{props.text}</div>
      </div>
    </div>
  )
}

interface SpeedToLeadProps {
  title: string;
  onClick(action: string, route: string): void;
}

const SpeedToLead: React.FC<SpeedToLeadProps> = (props) => {

  const classes = useStyles({});

  return (
    <div className={classes.mainContainer}>
      <div>
        <div className={classes.title}>{props.title}</div>
        <Grid container className={classes.container}>
          <Grid item xs={12} md={6} sm={12} className={classes.flexLeftBox}>
            <FullImage src={iconRobot} />
          </Grid>
          <Grid item xs={12} md={6} sm={12} className={classes.flexBox}>

            <LeadItem
              item={1}
              title="Receive"
              text="When someone replies or clicks through, you’ll receive an instant Text Notification from Galilaio. Simply click the link and it will redirect you to your prospect’s profile for easy engagement."
            />

            <LeadItem
              item={2}
              title="Review"
              text="When someone replies or clicks through, you’ll receive an instant Text Notification from Galilaio. Simply click the link and it will redirect you to your prospect’s profile for easy engagement."
            />

            <LeadItem
              item={3}
              title="Respond"
              text="When someone replies or clicks through, you’ll receive an instant Text Notification from Galilaio. Simply click the link and it will redirect you to your prospect’s profile for easy engagement."
            />
            <div className={classes.bottomButton}>
              <HomeButton text="Get started" onClick={() => props.onClick('signup', '')} />
            </div>

          </Grid>
        </Grid>
      </div>
    </div>
  )
};
export default SpeedToLead;

const useStyles = makeStyles(theme => ({
  mainContainer: {
    backgroundColor: '#F6F7F7',
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  container: {
    maxWidth: 1100,
    padding: 80,
    [theme.breakpoints.down('md')]: {
      padding: 30
    },
    [theme.breakpoints.down('sm')]: {
      padding: 20
    }
  },
  title: {
    textAlign: 'center',
    color: '#577093',
    fontFamily: 'Asap',
    fontSize: '34px',
    letterSpacing: 0,
  },
  itemContainer: {
    display: 'flex',
    paddingBottom: 40
  },
  itemNumberContainer: {
    display: 'flex'
  },
  itemNumber: {
    color: '#FDFEFE',
    fontSize: 20,
    textAlign: 'center',
    backgroundColor: '#00ABCA',
    borderRadius: '50%',
    width: 35,
    height: 35,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex'
  },
  itemTextContainer: {
    paddingLeft: 20
  },
  itemText: {
    color: '#303F51',
    fontSize: 24,
    fontWeight: 500
  },
  itemDescription: {
    fontSize: 16,
    fontWeight: 400
  },
  bottomButton: {
    display: 'flex', 
    justifyContent: 'flex-start', 
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center' 
    }
  },
  flexBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: "100%",
    padding: 20,
    [theme.breakpoints.down('sm')]: {
      padding: 0 
    }
  },
  flexLeftBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: "100%",
  }
}));


// WEBPACK FOOTER //
// ./src/pages/home/components/SpeedToLead.tsx